/* eslint-disable react/no-unused-state,react/no-unescaped-entities */
import React, { memo, useState } from "react";
import { Card, CardBody, Col, ButtonToolbar, Spinner } from "reactstrap";

import { Link } from "react-router-dom";
import { MdModeEdit, MdInsertDriveFile, MdLock } from "react-icons/md";
import DataTable from "../../../../shared/components/DataTable";
import { withRouter } from "react-router-dom";
import CustomSearch from "./CustomSearch";
import { toggleUser } from "../../actions/user.actions";
import { connect } from "react-redux";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css";
import "../customisedCss/alert.css";
import AccessControl from "../../../../shared/components/AccessControl";
import { permissionsConstants } from "../../../../constants/permission.constants";
import { accessControlFn } from "../../../../utils/accessControl";
import Avatar from "react-avatar";
import { getFormValues } from "redux-form";
import RolesCard from "../../../Roles/RolesCard";

const { VIEW_USERS, MANAGE_USER, VIEW_ROLES } = permissionsConstants;

const UsersTable = memo((props) => {
    const { dataState, fetchData, dispatch, toggleuser, permissions, allUsers } = props;

    const [searchKey, setSearchKey] = useState("");
    const count = dataState && dataState.response ? dataState.response.count : 0;

    const toggleUserFn = (row) => {
        confirmAlert({
            message: `Are you sure you want to ${row.active ? "disable" : "enable"} this user`,
            buttons: [
                {
                    label: "Yes",
                    onClick: () => dispatch(toggleUser(row.username, row.active, "getAllUsers", allUsers.request)),
                },
                {
                    label: "No",
                    onClick: () => null,
                },
            ],
        });
    };

    const columns = [
        {
            accessor: "id",
            name: "",
            Cell: (row) => <Avatar round={true} size="32" name={`${row.firstName} ${row.lastName}`} />,
            sortable: true,
            sortKey: "id",
            permissions: "ROLE_VIEW_USERS",
        },
        {
            accessor: "firstName",
            name: "First Name",
            filterable: true,
            sortable: true,
            sortKey: "firstName",
            permissions: "ROLE_VIEW_USERS",
        },
        {
            accessor: "lastName",
            name: "Last Name",
            filterable: true,
            sortable: true,
            sortKey: "lastName",
            permissions: "ROLE_VIEW_USERS",
        },
        {
            accessor: "email",
            name: "Email",
            filterable: true,
            sortable: true,
            sortKey: "email",
            permissions: "ROLE_VIEW_USERS",
        },
        {
            accessor: "mobileNo",
            name: "Phone Number",
            sortable: true,
            sortKey: "mobileNo",
            permissions: "ROLE_VIEW_USERS",
        },
        {
            accessor: "active",
            name: "Status (click to toggle)",
            sortable: true,
            sortKey: "active",
            renderHeader: () => (
                <span>
                    Status <small>(click to toggle)</small>
                </span>
            ),
            filterable: true,
            Cell: (row) => (
                <button type="button" id={`toggle-btn-${row.active ? "enabled" : "disabled" }-${row.id}`} onClick={() => accessControlFn(permissions, [], toggleUserFn, row)} className ={`btn ${row.active ? "btn-success" : "btn-secondary"} badge mb-0`}>
                    {toggleuser.loading && row.username === toggleuser.request.username ? <Spinner size="sm" /> : <span>{row.active ? "Enabled" : "Disabled"}</span>}
                </button>
            ),
            permissions: "ROLE_DISABLE_USER_ROLE",
        },
    ];

    const handleAction = (row, action) => {
        if (action.name === "view_users") {
            props.history.push(`${props.location.pathname}/view/${row.email}`);
        } else if (action.name === "edit_users") {
            props.history.push(`${props.location.pathname}/edit/${row.email}`);
        } else if (action.name === "manageRoles") {
            props.history.push(`${props.location.pathname}/roles/${row.username}`);
        }
    };

    const sortFn = (pageNum, pageSize, column) => {
        let sortOrder = "ASC";
        if (!allUsers.loading) {
            if (allUsers.request && allUsers.request.sortOrder) {
                sortOrder = allUsers.request.sortOrder === "ASC" ? "DESC" : "ASC";
            }
            fetchData({
                ...allUsers.request,
                pageNum,
                pageSize,
                sortKey: column.sortKey,
                sortOrder,
            });
        }
    };

    const actions = [
        {
            name: "view_users",
            btnText: "View",
            btnAction: handleAction,
            btnClass: "success",
            btnIcon: MdInsertDriveFile,
            permissions: [VIEW_USERS],
            showButton: false,
        },
        {
            name: "edit_users",
            btnText: "Edit",
            btnAction: handleAction,
            btnClass: "default",
            btnIcon: MdModeEdit,
            permissions: [MANAGE_USER],
            showButton: false,
        },
        {
            name: "manageRoles",
            btnText: "Manage Roles",
            btnAction: handleAction,
            btnClass: "info",
            btnIcon: MdLock,
            permissions: [MANAGE_USER],
            showButton: false,
        },
    ];

    // const columnsPermissions = ["ROLE_MANAGE_USERS", "ROLE_VIEW_USERS"];

    const handleSubmit = (values) => {
        setSearchKey(values.searchWord);
        fetchData({
            ...allUsers.request,
            pageNum: 1,
            searchWord: values.searchWord || "",
        });
    };

    const loadData = (pageNum, pageSize) => {
        fetchData({
            ...allUsers.request,
            pageNum,
            pageSize,
            searchWord: searchKey,
        });
    };

    return (
        <Col md={12} lg={12}>
            <Card>
                <AccessControl allowedPermissions={[VIEW_ROLES]} renderNoAccess={() => null}>
                    <RolesCard />
                </AccessControl>
                <br />
                <CardBody>
                    <div className="card__title">
                        <h5 className="bold-text">Users</h5>

                        <AccessControl allowedPermissions={[MANAGE_USER]} renderNoAccess={() => null}>
                            <ButtonToolbar className="products-list__btn-toolbar-top">
                                <Link className="btn btn-primary products-list__btn-add" to="/users/add" id="link-create-user" style={{ width: "12rem" }}>
                                    Add new user
                                </Link>
                            </ButtonToolbar>
                        </AccessControl>
                    </div>
                    <DataTable
                        columns={columns}
                        loading={dataState && dataState.loading}
                        data={dataState && dataState.response ? dataState.response.content : []}
                        count={count}
                        countName="Users"
                        defaultPageSize={10}
                        defaultPageNumber={1}
                        loadData={loadData}
                        error={dataState && dataState.error}
                        bordered={true}
                        striped={true}
                        hover={true}
                        permissions={permissions}
                        actions={actions}
                        clearSearch={() => {}}
                        responsive
                        customSearch={
                            <CustomSearch
                                pageNumer={1}
                                initialValues={{
                                    pageNumber: 1,
                                    pageSize: 10,
                                    searchKey: "",
                                }}
                                pageSize={10}
                                onSubmit={handleSubmit}
                                placeholder="Search by keyword (username, email, ...)"
                            />
                        }
                        sortFn={sortFn}
                        searchKey={searchKey}
                        serverside
                    />
                </CardBody>
            </Card>
        </Col>
    );
});

export default connect((state) => ({
    searchValues: getFormValues("custom_search")(state),
    permissions: state.permissions && state.permissions.response,
    allUsers: state.getusers,
    toggleuser: state.toggleuser,
}))(withRouter(UsersTable));
